export default __webpack_public_path__ + "static/media/bitcoin-logo.e5be9797.png";